import { useEffect, useState } from 'react';
import packageJson from '../package.json';

global.appVersion = packageJson.version;

const CacheBuster = ({ children }) => {
  const [loading, setLoading] = useState(true);
  const [isLatestVersion, setIsLatestVersion] = useState(true);

  const refreshCacheAndReload = async () => {
    if (typeof window !== 'undefined' && window.caches) {
      const names = await caches.keys();
      await Promise.all(names.map(name => caches.delete(name)));
    }
    window.location.reload(true);
  };

  useEffect(() => {
    fetch('/meta.json')
      .then(res => res.json())
      .then(meta => {
        const latestVersion = meta.version;
        const currentVersion = global.appVersion;

        if (latestVersion !== currentVersion) {
          refreshCacheAndReload();
        } else {
          setIsLatestVersion(true);
          setLoading(false);
        }
      })
      .catch(() => setLoading(false));
  }, []);

  return children({ loading, isLatestVersion, refreshCacheAndReload });
};

export { CacheBuster };
